import { render, staticRenderFns } from "./AddAccount.vue?vue&type=template&id=769255f5"
import script from "./AddAccount.vue?vue&type=script&lang=ts"
export * from "./AddAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports